import { render, staticRenderFns } from "./AllInOne.vue?vue&type=template&id=bb04bd6a&scoped=true&"
import script from "./AllInOne.vue?vue&type=script&lang=js&"
export * from "./AllInOne.vue?vue&type=script&lang=js&"
import style0 from "./AllInOne.vue?vue&type=style&index=0&id=bb04bd6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb04bd6a",
  null
  
)

export default component.exports